module.exports = __webpack_public_path__ + "assets/header_triangle_button-909cd4.svg";